import { render } from "./OSApontaAgrupado.vue?vue&type=template&id=bd67ad10&scoped=true"
import script from "./OSApontaAgrupado.vue?vue&type=script&lang=js"
export * from "./OSApontaAgrupado.vue?vue&type=script&lang=js"

import "./OSApontaAgrupado.vue?vue&type=style&index=0&id=bd67ad10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd67ad10"]])

export default __exports__